import React, { useState } from 'react';

import { MFA_APP_KEY, MFA_SMS_KEY, MFA_EMAIL_KEY } from 'lib/mfa';
import { ActionButton, ButtonV2, TextInput } from 'components';

function ValidateAuthenticator({ onPrevious, onContinue, otpSecret, authenticator }) {
  const [otp, setOtp] = useState('');
  const [hasError, setHasError] = useState(false);

  const updateOtp = value => {
    setHasError(false);

    if (!/^\d{0,6}$/.test(value)) return;

    setOtp(value);
  };

  const otpIsValid = () => {
    return otp.length === 6;
  };

  const getTitle = () => {
    switch (authenticator.kind) {
      case MFA_APP_KEY:
        return 'Verify Authenticator App';
      case MFA_EMAIL_KEY:
        return 'Verify Email';
      case MFA_SMS_KEY:
        return 'Verify Text Message';
    }
  };

  const getDescription = () => {
    switch (authenticator.kind) {
      case MFA_APP_KEY:
        return 'Enter the single-use code from your Authenticator app.';
      case MFA_EMAIL_KEY:
        return 'An authorization code was sent to your email address. Enter the single-use code below to verify your email and complete setup.';
      case MFA_SMS_KEY:
        return 'An authorization code was sent to your phone number. Enter the single-use code below to verify your phone number and complete setup.';
    }
  };

  const getSuccessMessage = () => {
    switch (authenticator.kind) {
      case MFA_APP_KEY:
        return 'Authenticator App successfully added.';
      case MFA_EMAIL_KEY:
        return 'Email successfully added.';
      case MFA_SMS_KEY:
        return 'Phone number successfully added.';
    }
  };

  const saveAuthenticator = async () => {
    if (!otpIsValid()) return;

    try {
      await req.mfaSaveAuthenticator({
        kind: authenticator.kind,
        otp_secret: otpSecret,
        otp_code: otp
      });
      setHasError(false);
      Actions.showFlash(getSuccessMessage());
      onContinue({ otp });
    } catch {
      setHasError(true);
    }
  };

  return (
    <>
      <div className="modal__header mfa-add-method">
        <div className="modal__header-title">
          <ActionButton className="mfa__back" iconName="back" size={14} onClick={onPrevious} />
          {`${getTitle()} `}
          <label>
            <strong>Step 3</strong> / 3
          </label>
        </div>
      </div>
      <div className="modal__container">
        <div className="mfa-add-method__description">{getDescription()}</div>
        <div className={`mfa-add-method__code-container${hasError ? '-error' : ''}`}>
          <TextInput value={otp} onChange={updateOtp} placeholder="000 000" />
          {hasError && <label>Incorrect Code. Please try again.</label>}
        </div>
      </div>
      <div className="modal__footer">
        <ButtonV2
          className="button--primary"
          label="Save & Finish"
          onClick={saveAuthenticator}
          disabled={!otpIsValid()}
        />
      </div>
    </>
  );
}

export default ValidateAuthenticator;
